/*	MARK: Ai5 Machine Data models
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus, MachineSignal } from './machine-schemas';
const ObjectID = require('bson-objectid');

@inject(DataService, Api, Router)
export class MachinePrediction {
	/** Components methods **/
	constructor(ds, api, router){
		// Services
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		this.sampleValues = {};
		// Component variables
		this.prediction	= 0;
	}

	// MachineID
	activate(params){ this.id = params.id;this.pid 	= params.pid;} 
	
	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/
		this.init();
	}

	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
j			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService
			============================================
		*/
		let machine = this.ds.app_data.machine;

		if(!machine){
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
				return this.getDataset(this.machine);
			}).then(res => {
				this.handleDatasetResponse(res);
				// Test block
				let sampleValues = this.generateRangeSampleValues(this.dataset.summary.description, 100);
				this.sampleValues = sampleValues;
				// end test block

				// Load Archive prediction (PID) if need id
				if(this.pid){ this.loadArchive(this.pid) }
				
			});
		}
		else{
			// Load machine
			machine.features = machine.features
			this.machine = machine;
			this.selected_algorithm = this.machine.algorithm
			// Get remote dataset
			this.getDataset(machine).then(res => {
				this.handleDatasetResponse(res);
				// Test block
				let sampleValues = this.generateRangeSampleValues(this.dataset.summary.description, 100);
				this.sampleValues = sampleValues;
				// end test block


				// Load Archive prediction (PID) if need id
				if(this.pid){ this.loadArchive(this.pid) }
				
			});
		}
	}



	/** Init Archive ***/
	loadArchive(pid){
		// Change Stage status (in process)
		// this.stage = Stages.InProcess;

		// Load remote data
		this.getPrediction(pid).then(response => {
			this.handleGetPrediction(response);
		});
	}
	
	/** API Calls **/


	getPrediction(pid){
		let id			= this.machine._id;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/"+pid, "GET");
		return this.api.get(request);
	}

	handleGetPrediction(response){
		// Display prediction
		if(response.status === 200){
			//console.log("response => ", response.data);
			// Apply prediction
			this.prediction 	= response.data.prediction;
			this.sampleValues	= response.data.sample;
			this.predictionToDataService(response.data);
			/*
			this.prediction 	= response.data.prediction;
			this.sampleValues	= response.data.sample;
			let pred = {
				prediction	: this.prediction[0],
				sample		: this.sampleValues,
				credentials : {
					uid		:this.machine.uid,
					muid	:this.machine._id,
					type	:"Quick"
				}
			}
			pred._id = (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();
			this.ds.app_data.prediction = pred;
			*/
		}
	}
	
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			machine.features = machine.features
			this.machine = machine
			this.ds.app_data.machine = machine;
			
		};
	}

	getDataset(machine){
		let request		= new Request("/api/v2/datasets/id/_id?", "GET")
		let id			= machine.dataset.split("-")[0];
		let params		= new URLSearchParams({_id:id});
		request.url		= request.url + params;
		return this.api.get(request);
	}

	handleDatasetResponse(response){
		let status = response.status;
		if(status === 200){
			let dataset 	= response.data;
			this.dataset 	= dataset;
			this.ds.app_data.dataset = dataset;
		}
	}

	postPrediction(machine){
		// Machine ID
		let id 				= machine._id;
		// Create request
		let request 	= new Request("/api/v2/machines/" + id + "/predict/", "POST");
		// Copy machine
		let req_machine = { ... machine };

		// let body 		= { signal:MachineSignal.Predict, machine:req_machine};
		let body 		= { oper:"predict", signal:MachineSignal.Predict, machine:req_machine, sample:machine.sample };


		request.body	= JSON.stringify(body);
		// Add Auth token
		request.headers["Authorization"] = "Bearer " + this.accessToken;
		// Perform api call - Train
		return this.api.post(request);
	}

	handlePostPrediction(response){
		let status = response.status;
		if(status === 200){
			let json_response = JSON.parse(response.data);
			let data 		  = json_response.data;
			this.prediction   = data[0];
			/*
			
			// debug // console.log("prediction => ", this.prediction);
			// To Data service
			let pred = {
				prediction	: data[0],
				sample		: this.sampleValues,
				credentials : {
					uid		:this.machine.uid,
					muid	:this.machine._id,
					type	:"Quick"
				}
			}
			pred._id = (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();
			this.ds.app_data.prediction = pred;
			*/
			this.predictionToDataService(data);
		}
	}

	predictionToDataService(data){
		let pred = {
				prediction	: this.prediction,
				sample		: this.sampleValues,
				credentials : {
					uid		:this.machine.uid,
					muid	:this.machine._id,
					type	:"Quick"
				}
			}
		pred._id = (this.pid) ? this.pid : ObjectID(Date.now()).toHexString();
		this.ds.app_data.prediction = pred;
	}

	requestPredictQuota(machine){
		// Auth Request
		let subsToken		= this.ds.user.subs;
		let uid				= machine.uid;
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-token", "POST");
		let machine_quota 	= { quota: machine.quota } // prediction
		// Add body
		let body			= { machine_quota:machine_quota, uid:machine.uid };
		request.body		= JSON.stringify(body);
		// Add subs header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}

	/** Action calls **/
	_predict(sample){
		let machine			= {... this.machine };
		let keys 			= machine.features // Object.keys(sample)

		// Prepare data
		let sample_vector	= []
		keys.forEach(key => {
			let val = parseFloat(sample[key].value);
			sample_vector.push(val);
		});
		machine["sample"]	= sample_vector;
		machine.algorithm	= "predict";
		// End prepare data for machine
		
		this.postPrediction(machine).then(response => {
			this.handlePostPrediction(response);
			
		});
	}

	predict(sample){
		let machine			= {... this.machine };

		// Request operation Token
		let machine_quota 	= { ... machine };
		machine_quota.quota = 1; // quota equals to a single point

		// Request machine quota
		this.requestPredictQuota(machine_quota).then(resQuota => {
			let status	= resQuota.status;
			if(status === 200){
				this.accessToken = resQuota.data.oper_token;
				// Procede with data preparation
				let keys 			= machine.features // Object.keys(sample)
				let sample_vector	= [];
				keys.forEach(key => {
					let val = parseFloat(sample[key].value);sample_vector.push(val);
				});
				machine["sample"]	= sample_vector;
				machine.algorithm	= "predict";
				return this.postPrediction(machine);
			}
		})
		.then(response => {
			this.handlePostPrediction(response);
		})
		.catch( (e) => {
			console.log("some err ocurr ", e);
		});
	}

	
	toFixed = (n, fixed) => ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);

	// Generate sample
	generateRangeSampleValues(fields, range){
		/*	MARK: Genreate sample from features statistics
			============================================
		  	fields => { max, min, mean, variable_name }
			1 get max-min for every label-field
			2 divide in range the diff i.e => diff/100
			3 iterate from min plus step-diff
			4 map output to hash => return
		 */
		// Output
		let fields_map = {}
		fields.forEach((field, idx) => {
			let step = (field.max - field.min) / range;

			// If step equals 0, setup default step value
			//console.log(field, step);
			if(step === 0){
				// step 		= 1 / field.mean;
				step		= 0.01;
				field.max	= field.mean * 2
				field.min	= field.mean - (field.mean * 2)
			}
			// console.log("field 2 => ", field, step);
			
			step = this.toFixed(step, 4)
			let seq = [];
			// generate samples in length of range
			for(let i=0; i < (range - 1); i++){
				if (i === 0) { seq.push(field.min);}
				else{seq.push(seq[i-1] + step)}
			}
			// Update output map
			fields_map[field.variable] = {
				id:"field_" + idx,
				idr:"range_" + idx,
				seq:seq,
				min:field.min,
				max:field.max,
				mean:field.mean,
				step:step,
				value:field.mean
			};
		})
		return fields_map;				
	}

	/** Component Events **/
	onNumberInput(idr, val){
		let range_input 	= document.querySelector("#"+idr);
		range_input.value 	= val;
	}

	onRangeInput(id, val){
		let field_input 	= document.querySelector("#"+id);
		field_input.value 	= val;
	}
	/** Navigation calls **/
}
